<div class="flex container" prlwResponsive>
  <div class="flex column section bid" prlwResponsive>
    <div class="flex header" prlwResponsive>
      <div>Объем</div>
      <div class="grow">Цена за ед.</div>
      <div>Тотал</div>
    </div>
    <div class="overflow-container" prlwOverflowFader prlwResponsive>
      <div
        *ngFor="let item of bid"
        class="flex item"
        [style]="getFillStyle(item[1], '#00ff4735')"
      >
        <div>{{ item[1] }}</div>
        <div class="grow">
          {{ item[0] | delimitNumber }}
        </div>
        <div>
          {{ item[0] * item[1] | delimitNumber }}
        </div>
      </div>
    </div>
  </div>
  <div class="flex column section ask" prlwResponsive>
    <div class="flex header" prlwResponsive>
      <div>Объем</div>
      <div class="grow">Цена за ед.</div>
      <div>Тотал</div>
    </div>
    <div class="overflow-container" prlwOverflowFader prlwResponsive>
      <div
        *ngFor="let item of askWithSorting"
        class="flex item"
        [style]="getFillStyle(item[1], '#fae1df', getAskDirection())"
      >
        <div>{{ item[1] }}</div>
        <div class="grow">
          {{ item[0] | delimitNumber }}
        </div>
        <div>
          {{ item[0] * item[1] | delimitNumber }}
        </div>
      </div>
    </div>
  </div>
</div>
